<template>
  <div class="header">
    <h1>管理者群組編輯</h1>
  </div>
  <div
    class="col-12 d-flex align-items-center justify-content-between pt-4 col-12"
  >
    <span class="text-nowrap col-2 text-center">管理者群組</span>

    <div class="col-10 d-flex align-items-center position-relative">
      <input
        v-model="payload.name"
        class="rounded-pill border info"
        placeholder="請輸入管理者群組名稱"
      />
    </div>
  </div>
  <div
    class="col-12 d-flex align-items-center justify-content-between pt-4 col-12"
  >
    <span class="text-nowrap col-2 text-center">群組描述</span>

    <div class="col-10 d-flex align-items-center position-relative">
      <input
        v-model="payload.content"
        class="rounded-pill border info"
        placeholder="請輸入管理者群組描述"
      />
    </div>
  </div>
  <div class="group-wrapper">
    <div
      v-for="(item, i) in permissionList"
      :key="item"
      class="col-12 pt-4 col-12 group"
    >
      <div class="d-flex justify-content-between align-items-center">
        <p
          class="text-nowrap col-1 text-center"
          style="font-weight: 500; margin-bottom: 10px"
        >
          {{ item.title }}
        </p>
        <button
          class="is-home"
          :class="{ 'home-active': payload.index_router === item.title }"
          @click="setIndexRouter(item.title, i)"
        >
          設為首頁
        </button>
      </div>
      <div class="options-wrapper">
        <div
          v-for="(option, index) in item.details"
          :key="option"
          class="options"
          :class="
          Object.values(payload.authdata).findIndex((e) => e === option.name) >= 0
              ? 'active'
              : ''
          "
        >
          <div
            class="radio"
            :class="
              Object.values(payload.authdata).findIndex((e) => e === option.name) >= 0
                ? 'radio-active'
                : ''
            "
            @click="addAuthData(i, index)"
          >
            <div />
          </div>
          {{ option.title }}
        </div>
      </div>
    </div>
  </div>

  <div class="col-12 d-flex align-items-center justify-content-center">
    <button
      @click="submit"
      class="btn btn-outline-primary user-btn rounded-pill col-3 ms-2"
    >
      完成
    </button>
  </div>
  <MsgBox
    :show="showMsgBox"
    :errorCode="errorCode"
    :errorMsg="errorMsg"
    @close="showMsgBox = false"
  />
</template>
<script>
import { ref } from '@vue/reactivity'
import MsgBox from '@/components/MsgBox.vue'
import usePermission from '@/composables/usePermission'
import { computed } from '@vue/runtime-core'
import { useRoute, useRouter } from 'vue-router'
export default {
  components: {
    MsgBox,
  },
  setup() {
    const { get_group_info, create_group, edit_group, get_group_list } =
      usePermission()
    const route = useRoute()
    const router = useRouter()
    const showMsgBox = ref(false)
    const showPassword = ref(false)
    const errorMsg = ref('')
    const errorCode = ref('')
    const formList = ref([])
    const permissionList = ref([])
    const payload = ref({
      id: null,
      name: null,
      content: null,
      authdata: [],
      index_router: null,
    })
    const groupList = ref([])
    const getList = async () => {
      if (route.query.id) {
        payload.value.id = +route.query.id
        const group_list = await get_group_list()
        groupList.value = group_list.ret.data
        const item = groupList.value.find((e) => e.id === +route.query.id)
        payload.value.name = item.name
        payload.value.content = item.content
        payload.value.authdata = item.authdata
        payload.value.index_router = item.index_router
      }
      const res = await get_group_info()
      let data = []
      if (res.error) {
        showMsgBox.value = true
        errorMsg.value = res.msg
        errorCode.value = res.error
      } else {
        for (const i of Object.values(res.ret['role-info'])) {
          const index = data.findIndex((e) => {
            return e.title === i.group
          })
          if (index >= 0) {
            data[index].details.push(i)
          } else {
            data.push({
              title: i.group,
              isHome: false,
              details: [i],
            })
          }
        }
      }
      data.forEach((e) => {
        e.details.sort((a, b) => a.order_sort - b.order_sort)
        e.details.sort((a, b) => b.is_index - a.is_index)
      })
      permissionList.value = data
    }
    getList()
    const getInfo = computed(() => {
      return formList.value.find((e) => {
        return e.id === +route.params.id
      })
    })

    const setIndexRouter = (title, itemIndex) => {
      payload.value.index_router = title
      const isIndex = permissionList.value[itemIndex].details.find(
        (e) => e.is_index,
      )
      const has = payload.value.authdata.find((e) => e === isIndex.name)
      if (!has) {
        payload.value.authdata.push(isIndex.name)
      }
    }
    const addAuthData = (itemIndex, detailsIndex) => {
      const item = permissionList.value[itemIndex].details[detailsIndex]
      if (payload.value.authdata.findIndex((e) => e === item.name) < 0) {
        payload.value.authdata.push(item.name)
        const isIndex = permissionList.value[itemIndex].details.find(
          (e) => e.is_index,
        )
        payload.value.authdata.push(isIndex.name)
      } else {
        const remove = payload.value.authdata.findIndex((e) => e === item.name)
        payload.value.authdata.splice(remove, 1)
      }
    }

    const submit = async () => {
      if (payload.value.id) {
        const res = await edit_group(payload.value)
        if (res.error) {
          showMsgBox.value = true
          errorMsg.value = res.msg
          errorCode.value = res.error
        } else {
          showMsgBox.value = true
          errorMsg.value = '編輯成功'
          setTimeout(() => {
            router.push('/user-management/user-group-list')
          }, 1000)
        }
      } else {
        const res = await create_group(payload.value)
        if (res.error) {
          showMsgBox.value = true
          errorMsg.value = res.msg
          errorCode.value = res.error
        } else {
          showMsgBox.value = true
          errorMsg.value = '新增成功'
          setTimeout(() => {
            router.push('/user-management/user-group-list')
          }, 1000)
        }
      }
    }
    return {
      errorCode,
      showMsgBox,
      errorMsg,
      getInfo,
      getList,
      formList,
      showPassword,
      permissionList,
      payload,
      addAuthData,
      submit,
      groupList,
      setIndexRouter,
    }
  },
}
</script>
<style lang="scss" scoped>
.header {
  padding: 40px 0px;
}
h1 {
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 33px;
  color: #000000;
}
.user-img {
  width: 160px;
  height: 160px;
  border: 1px #eff0f6 solid;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 64px auto 16px;
}
.info {
  width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 60px 0 32px;
  outline-color: #d1e5ef;
  color: #4d4d4d;
}
.state {
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 60px 0 32px;
  outline-color: #d1e5ef;
  color: #4d4d4d;
}
input::placeholder {
  font-size: 16px;
}
select {
  background: url('~@/assets/icons/arrow-down.svg') no-repeat scroll 97% center
    transparent;
  appearance: none;
  color: #4d4d4d;
}
.options-wrapper {
  display: flex;
  flex-wrap: wrap;
}
.options {
  display: flex;
  align-items: center;
  width: 50%;
  color: #4d4d4d;
  font-size: 13px;
  margin: 5px 0;
  font-weight: 300;
}
.radio {
  width: 20px;
  height: 20px;
  margin-right: 10px;
  border-radius: 999px;
  border: 1px solid #cccccc;
  padding: 4px;
  cursor: pointer;
}
.active {
  color: #177baf;
}
.radio-active {
  border: 1px solid #177baf;
  div {
    width: 100%;
    height: 100%;
    border-radius: 999px;
    background: #177baf;
  }
}
.group-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 40px;
  margin-top: 50px;
}
.group {
  width: 340px;
  border: 1px #eff0f6 solid;
  border-radius: 20px;
  padding: 16px;
}

.copy {
  right: 32px;
}

.user-btn {
  height: 48px;
  margin: 24px 0 72px 0;
}
.show-password {
  right: 32px;
  position: absolute;
  cursor: pointer;
}
.is-home {
  font-size: 12px;
  font-weight: 300;
  cursor: pointer;
  padding: 5px 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  background-color: transparent;
}
.home-active {
  color: #fff;
  border: 1px solid #177baf;
  background-color: #177baf;
  padding: 5px 10px;
  font-weight: 400;
}
</style>
